const dev = typeof window !== 'undefined' && window.location.hostname === 'localhost'
export const assetUrl = (asset, base = 'marketing') => dev
  ? `https://podandhive.s3.ap-southeast-2.amazonaws.com/assets/shivoo/${base}/${asset}`
  : `https://www.podandhive.com/assets/shivoo/${base}/${asset}`
export const cssAssetUrl = asset => `url(${assetUrl(asset)})`

export const post = (path, body) => {
  const host = window.location.hostname.includes('localhost') ? 'http://localhost:4000/'
    : window.location.hostname.includes('staging') ? 'https://ap.staging.podandhive.com:4000/'
      : window.location.hostname.includes('preview') ? 'https://preview.podandhive.com:4000/'
        : 'https://ap.podandhive.com:4000/'

  return fetch(
    host + path,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' }
    }
  )
}